import { AppStrings } from "../../../../../../utils/constants/AppStrings";
import MonthlyChallengeCard from "./MonthlyChallengeCard";
import MonthlyTierProgressBar from "./MonthlyTierProgressBar";
import {
  formatTierRewardLabel,
  getTierProgressSummary,
} from "../monthlyChallengeHelpers";
import useRewardCurrencyLabel, {
  useRewardSecondaryCurrencyLabel,
} from "../useRewardCurrencyLabel";

// Read-only challenge card used inside a past (settled) month group. All tiers
// are claimed and there is no Edit Progress action — a past period cannot be
// adjusted from here.

const ReadOnlyChallengeCard = ({ challenge, status, testId }) => {
  const rewardCurrencyLabel = useRewardCurrencyLabel();
  const rewardSecondaryCurrencyLabel = useRewardSecondaryCurrencyLabel();
  // Derive progress from the claimed milestones rather than assuming a settled
  // month is 100% — real API data may report a partially completed past period.
  const reachedCount = challenge.milestones.filter(
    (milestone) => milestone.claimed,
  ).length;
  const summary = getTierProgressSummary(
    reachedCount,
    challenge.milestones.length,
  );
  const milestones = challenge.milestones.map((milestone) => ({
    threshold: milestone.threshold,
    claimed: milestone.claimed,
    rewardLabel: formatTierRewardLabel(
      {
        amount: milestone.rewardAmount,
        currency: milestone.rewardCurrency,
        reward_type: milestone.rewardType,
      },
      {
        primaryCurrencyLabel: rewardCurrencyLabel,
        secondaryCurrencyLabel: rewardSecondaryCurrencyLabel,
      },
    ),
  }));
  const countFromChallenge = Number(challenge.count);
  const goalFromChallenge = Number(challenge.goal);
  let count = 0;
  if (Number.isFinite(countFromChallenge)) {
    count = countFromChallenge;
  } else if (reachedCount > 0) {
    count = Number(milestones[reachedCount - 1]?.threshold) || 0;
  }
  const goal =
    Number.isFinite(goalFromChallenge) && goalFromChallenge > 0
      ? goalFromChallenge
      : Number(milestones[milestones.length - 1]?.threshold) || 0;

  return (
    <MonthlyChallengeCard
      title={challenge.title}
      subtitle={challenge.subtitle}
      counterLabel={challenge.counterLabel}
      tierLabel={challenge.tierLabel}
      status={status}
      defaultOpen={false}
      testId={testId}
    >
      <MonthlyTierProgressBar
        progressLabel={AppStrings.USER_GAME_PASS_MONTHLY_CURRENT_TIER_PROGRESS}
        challengesText={summary.challengesText}
        percentLabel={summary.percentLabel}
        milestones={milestones}
        reachedCount={reachedCount}
        count={count}
        goal={goal}
        testId={`${testId}-tier`}
      />
    </MonthlyChallengeCard>
  );
};

export default ReadOnlyChallengeCard;
